import React from 'react'
import { IconPassword } from '../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Form, FormPassword, FormPasswordValidate, FormSubmit } from '../../../../../shared/form/form'
import { Card } from '../../../../../shared/card/card'
import { useApiFormPasswordUpdate } from '../../../../../api-new/state/auth'

export function PasswordUpdate() {
  const apiFormPasswordUpdate = useApiFormPasswordUpdate()

  // A refusal (a wrong current password, say) is shown by the form with its
  // reference, and the passwords typed stay. The page used to keep the
  // failure itself and render the error object as text, which React refuses:
  // a failed update took the page down.
  const handleSubmit = async data => {
    await apiFormPasswordUpdate.post(data)
    apiFormPasswordUpdate.init()
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconPassword} text="Update password">
        <Card title="update password">
          <Form state={apiFormPasswordUpdate.form} submitting={apiFormPasswordUpdate.submitting} onSubmit={handleSubmit}>
            <FormPassword label="current password" name="oldPassword" required />
            <FormPasswordValidate label="new password" name="newPassword" required />
            <FormSubmit text="update password" />
          </Form>
        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
